import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { trackError } from "@/lib/tracking-helpers";

// Register Chart.js components globally before app loads
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

// Global error tracking with console output
window.addEventListener('error', (event) => {
  console.error('[GLOBAL ERROR]', event.message, event.error, event.filename, event.lineno);
  trackError(
    event.message,
    event.error?.stack,
    `Global Error: ${event.filename}:${event.lineno}:${event.colno}`
  );
});

// Track unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('[UNHANDLED REJECTION]', event.reason);
  trackError(
    event.reason?.message || String(event.reason),
    event.reason?.stack,
    'Unhandled Promise Rejection'
  );
});

createRoot(document.getElementById("root")!).render(<App />);
